<template>

    <script type="application/ld+json" v-html="data"></script>

</template>

<script>

import Vuex from 'vuex'

export default {

    name: 'structured-data',

    computed: {

        ...Vuex.mapGetters([ 'page', 'lang' ])

    },

    watch: {

        page: function () {

            this.loadContent()

        },

        lang: function () {

            this.loadContent()

        }

    },

    data () {
        return {
            data: {},
            existingPages: []
        }
    },

    mounted () {

        this.loadContent()

    },

    methods: {

        loadContent () {

            if (this.page) {

                if (this.existingPages.indexOf(this.page) > -1) {

                    this.$http.get(`/structureddata/${this.page}_${this.lang}.json`)
                        .then(response => {

                            this.data = response.bodyText

                        })
                        .catch(() => {

                            this.data = {}

                        })
                }
            }
        }
    }

}
</script>

<style scoped lang="scss"></style>
